export default {
      id: "link-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#link-usage",
      toString: function () {
        return this.url;
      }
    }